module.exports = __webpack_public_path__ + "src/assets/images/down_arrow.74e3ce450830af77b57fabd34116b6b4.png";